import { RequestedRouteState } from '../../types';
import * as types from './types';

export const setRequestedRoute = (payload: RequestedRouteState) => {
  return {
    type: types.REQUESTED_ROUTE,
    payload,
  };
};
